import React, { Component } from "react";
import styled from "styled-components";
import Dropzone from "react-dropzone";
import Cropper from "react-cropper";
import LoadImage from "blueimp-load-image";
import fetch from "isomorphic-unfetch";
import * as fd from "form-data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCrosshairs,
  faUndo,
  faUpload,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
// import { faLocation } from "@fortawesome/pro-regular-svg-icons";
import dms2dec from "dms2dec";
import "cropperjs/dist/cropper.css";

import MapCoordinatesSelector from "./MapCoordinatesSelector";
import Status from "./Status";
import IconClose from "../../assets/images/deine-buga__image--close.svg";
import IconUploadFoto from "../../assets/images/deine-buga__image--upload-foto.svg";
import IconDelete from "../../assets/images/deine-buga__image--delete.svg";
import MapControlButtonWithText from "./MapControlButtonWithText";
import PluginCloseButton from "./PluginCloseButton";

const getColor = (props) => {
  if (props.isDragReject) {
    return "#c66";
  }
  if (props.isDragActive) {
    return "#777";
  }
  return "#AAA";
};

const ImageControls = styled.div.attrs({
  className: "ma1 absolute button",
})`
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
`;

const Rotate = styled.button.attrs({
  className: "bn bg-white pa2 button-reset ma1",
})`
  border-radius: 2.4rem;
  height: 2rem;
  box-sizing: border-box;
  color: rgba(129, 51, 78, 1);
  border: 1px solid rgba(129, 51, 78, 0.5);

  &:focus {
    outline-style: none;
  }
`;

const Container = styled.div.attrs({})`
  border-width: 1px;
  border-radius: 4px;
  border-color: ${(props) => getColor(props)};
  border-style: ${(props) =>
    props.isDragReject || props.isDragActive ? "solid" : "dashed"};
  background-color: ${(props) =>
    props.isDragReject || props.isDragActive ? "#eee" : ""};
`;

const Button = styled.button.attrs({
  className: (props) =>
    props.large ? "pv3 ph4 ba bg-white" : "pv2 ph3 ba bg-white",
})`
  border-color: rgba(129, 51, 78, 0.5);
  border-width: 2px;
  color: rgba(129, 51, 78, 1);

  &:disabled {
    opacity: 0.66;
    background-color: white;
    cursor: not-allowed;
  }
`;

const PhotoUploadWrapper = styled.div.attrs({
  className:
    "photoUploadWrapper z-2 w-100 right-0 left-0 absolute bottom-0 bg-white tl overflow-auto",
})`
  box-shadow: 0px -2px 18px 0px rgba(0, 0, 0, 0.075);
  max-width: 768px;
  margin: 0 auto;
  top: 15vh;
  box-sizing: border-box;
  line-height: 1.33rem;
  font-size: 1rem;

  .formErrors {
    margin: 0;
    padding: 1rem;

    ul > li {
      font-size: 14px;
    }
  }

  a {
    color: rgb(129, 51, 78) !important;
  }

  .maxWidthFormElement {
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
    max-width: 480px;
  }

  *:focus {
    outline: none !important;
  }

  .dropzone {
    border-style: none none solid;
    border-color: rgba(129, 51, 78, 0.5);
    border-width: 2px;
    border-radius: 0;
    padding: 0;
    flex-grow: 1;
    cursor: pointer;
    font-size: 0.875rem;
    text-align: left;
    line-height: 3rem;
    padding: 0 2rem 0 4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    input {
      line-height: 2rem;
    }
  }
`;

const PhotoUploader = styled.section.attrs({
  className: "overflow-y-auto pv4",
})`
  max-height: 100%;
`;
const PhotoUploadStatus = styled.section.attrs({
  className: "photoUploadStatus z-3 absolute top-0 bottom-0 left-0 right-0",
})`
  pointer-events: none;
`;

const PreviewImageWrapper = styled.div`
  position: relative;
  min-height: 120px;
  height: 33vh;
  max-height: 320px;
  background: rgb(177, 177, 177);
  box-shadow: inset 2px 4px 12px rgba(0, 0, 0, 0.16);

  .cropper-wrap-box {
    background-color: rgba(0, 0, 0, 0.33);
  }
`;

const ShowPhotoUploaderButton = styled.button.attrs({
  className: (props) =>
    props.large ? "pv3 ph4 ba bg-white" : "pv2 ph3 ba bg-white",
})`
  position: absolute;
  bottom: 100px;
  border-color: rgba(129, 51, 78, 0.5);
  border-width: 2px;
  color: rgba(129, 51, 78, 1);
`;

/**
 * PhotoUpload - React Component
 *
 * @class PhotoUpload
 * @extends {Component}
 */
class PhotoUpload extends Component {
  cropper = React.createRef();
  inputCaptureCamera = React.createRef();

  state = {
    isVisible:
      this.props.plugin && this.props.plugin.visibleOnLoad ? true : false,
    file: null,
    fileName: null,
    croppedImageUrl: null,
    croppedImage: null,
    croppedCanvas: null,
    base64Image: null,
    gpsCoordinates: {
      latitude: null,
      longitude: null,
    },
    isFetchingLocationViaGeolocationApi: false,
    termsAccepted: false,
    newsletterSubscription: false,
    isEmailValid: false,
    email: "",
    title: "",
    category: !!this.props.categories ? this.props.categories.find((element) => !!element.current).id : null,
    showStatusUploadSuccess: false,
    showStatusUploadFailure: false,
    showStatusUploadRequest: false,
    isMapLocationSelectorVisible: false,
    formErrors: {},
  };

  onShowPhotoUploader = (e) => {
    e.preventDefault();
    this.setState({
      isVisible: true,
    });
  };

  onClose = () => {
    // if (this.state.showStatusUploadSuccess == true) {
    //   window.location.reload();
    //   return;
    // }
    this.setState((prevState) => {
      return {
        isVisible: !prevState.isVisible,
      };
    });
  };

  resetCoordinates = (event) => {
    event.preventDefault();
    this.setCoordinates(null, null);
  };

  setCoordinates = (latitude, longitude) => {
    if (latitude && longitude) {
      latitude = parseFloat(latitude).toFixed(5);
      longitude = parseFloat(longitude).toFixed(5);
    }

    this.setState({
      gpsCoordinates: {
        latitude,
        longitude,
      },
    });
  };

  isUploadCriteriaComplete = () => {
    const { latitude, longitude } = this.state.gpsCoordinates;
    const { croppedImage, isEmailValid, termsAccepted } = this.state;

    return (
      latitude && longitude && isEmailValid && croppedImage && termsAccepted
    );
  };

  handleEmailChange = (event) => {
    const email = event.target.value;
    const isEmailValid = this.isEmailValid(email);
    this.setState({ email, isEmailValid });
  };

  handleTitleChange = (event) => {
    const title = event.target.value;
    this.setState({ title });
  };

  handleDescriptionChange = (event) => {
    const description = event.target.value;
    this.setState({ description });
  };

  handleCategoryChange = (event) => {
    const category = event.target.value;
    this.setState({ category });
  };

  handleTermsAcceptance = (event) => {
    const termsAccepted = event.target.checked;
    this.setState({
      termsAccepted,
    });
  };

  handleNewsletterSubscription = (event) => {
    const newsletterSubscription = event.target.checked;
    this.setState({
      newsletterSubscription,
    });
  };

  isEmailValid = (email) => {
    // Check if email valid with regex from:
    // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
    const regexForValidEmails = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexForValidEmails.test(email);
  };

  checkImageDataForGPSInfo = (data) => {
    if (data.exif) {
      const imageLatitude = data.exif.get("GPSLatitude")
        ? data.exif.get("GPSLatitude")
        : null;
      const imageLatitudeRef = data.exif.get("GPSLatitude")
        ? data.exif.get("GPSLatitudeRef")
        : null;
      const imageLongitude = data.exif.get("GPSLongitude")
        ? data.exif.get("GPSLongitude")
        : null;
      const imageLongitudeRef = data.exif.get("GPSLongitude")
        ? data.exif.get("GPSLongitudeRef")
        : null;

      if (
        imageLatitude &&
        imageLatitudeRef &&
        imageLongitude &&
        imageLongitudeRef
      ) {
        const coordinates = dms2dec(
          imageLatitude.slice(","),
          imageLatitudeRef,
          imageLongitude.slice(","),
          imageLongitudeRef
        );

        const latitude = Number.parseFloat(coordinates[0]).toFixed(5);
        const longitude = Number.parseFloat(coordinates[1]).toFixed(5);

        this.setCoordinates(latitude, longitude);
      } else {
        this.setCoordinates(null, null);
      }
    } else {
      this.setCoordinates(null, null);
    }
  };

  resetForm = () => {
    this.setState({
      file: null,
      fileName: null,
      croppedImageUrl: null,
      croppedImage: null,
      croppedCanvas: null,
      base64Image: null,
      gpsCoordinates: {
        latitude: null,
        longitude: null,
      },
      isFetchingLocationViaGeolocationApi: false,
      termsAccepted: false,
      isEmailValid: false,
      email: "",
      title: "",
      formErrors: {},
    });
  };

  /**
   *
   *
   * @param {*} files
   */
  onDrop = (files) => {
    console.log("--- here 1");
    const file = files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    )[0];

    LoadImage.parseMetaData(
      file,
      (data) => {
        if (!data.imageHead) {
          return;
        }
        this.checkImageDataForGPSInfo(data);
      },
      {
        maxMetaDataSize: 262144,
        disableImageHead: false,
      }
    );
    console.log("--- here 2");
    this.setState({
      file,
      fileName: file.name,
    });
  };

  blobToDataURL = (blob, callback) => {
    console.log("--- blobToDataURL");
    var a = new FileReader();
    a.onload = function (e) {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  };

  receivedBase64Image = (base64Image) => {
    console.log("--- receivedBase64Image");
    const {
      gpsCoordinates,
      email,
      title,
      description,
      category,
      termsAccepted,
      newsletterSubscription,
    } = this.state;

    this.setState({
      base64Image,
    });

    this.submitForm(
      gpsCoordinates,
      base64Image,
      email,
      title,
      description,
      category,
      termsAccepted,
      newsletterSubscription
    );
  };

  submitImageWithInfo = () => {
    if (this.isUploadCriteriaComplete()) {
      const { croppedCanvas } = this.state;

      const croppedCanvasResized = LoadImage.scale(
        croppedCanvas, // img or canvas element
        {
          maxWidth: 1440,
          maxHeight: 1440,
        }
      );

      if (croppedCanvasResized !== undefined) {
        croppedCanvasResized.toBlob((blob) => {
          if (blob !== null) {
            this.blobToDataURL(blob, this.receivedBase64Image);
          }
        }, "image/jpeg");
      }
    } else {
      this.setState((prevState) => {
        const isGpsCoordinatesAvailable =
          prevState.gpsCoordinates.latitude &&
          prevState.gpsCoordinates.longitude
            ? true
            : false;

        return {
          formErrors: {
            gpsCoordinates: isGpsCoordinatesAvailable,
            email: prevState.isEmailValid,
            terms: prevState.termsAccepted,
          },
        };
      });
    }
  };

  submitForm = async (
    gpsCoordinates,
    base64Image,
    email,
    title,
    description,
    category,
    termsAccepted,
    newsletterSubscription
  ) => {
    try {
      base64Image = base64Image.replace(/^data:image\/(png|jpeg);base64,/, "");

      // const url = `https://unt-cms.1tm.work/pois`;
      const url = `${process.env.REACT_APP_CMS_URL}/pois`; // uebermaps map: buga2019 - test
      //"http://ec2-18-184-165-91.eu-central-1.compute.amazonaws.com:1337/pois";
      const formData = new fd();
      const data = {
        lat: gpsCoordinates.latitude,
        lon: gpsCoordinates.longitude,
        email,
        title,
        description,
        category,
        newsletter: newsletterSubscription,
      };
      formData.append("data", JSON.stringify(data));
      // formData.append("lat", gpsCoordinates.latitude);
      // formData.append("lon", gpsCoordinates.longitude);
      // // formData.append("spot[picture]", base64Image);
      // formData.append("email", email);
      // formData.append("title", title);
      // formData.append("termsAccepted", termsAccepted);

      // strapi example
      // let newFile = {...this.state.croppedImage};
      // newFile.lastModifiedDate = new Date();
      // newFile.name = "photo";
      console.log("--- formData", data);
      // return;
      formData.append(`files.photo`, this.state.croppedImage);
      // strapi example

      // Set the PhotoUpload - Status to "Upload in Process"
      this.setState({
        showStatusUploadRequest: true,
      });

      // Submit the photo and info to the server
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      // If submission succeeded
      if (response.status === 200) {
        this.setState({
          showStatusUploadRequest: false,
          showStatusUploadSuccess: true,
        });
      }
    } catch (error) {
      console.log("error", error);
      // If submission failed
      this.setState({
        showStatusUploadRequest: false,
        showStatusUploadFailure: true,
      });
    }

    this.resetForm();
  };

  cropperReady = () => {
    console.log("--- cropperReady");
    this.cropImage();
  };

  cropImage = () => {
    console.log("--- cropImage");
    const croppedCanvas = this.cropper.current.getCroppedCanvas();

    if (croppedCanvas !== undefined) {
      croppedCanvas.toBlob((blob) => {
        if (blob !== null) {
          const croppedImageUrl = blob.srcObject
            ? blob.srcObject
            : URL.createObjectURL(blob);

          this.setState({
            croppedImageUrl,
            croppedImage: blob,
            croppedCanvas,
          });
        }
      }, "image/jpeg");
    }
  };

  // START: Rotate image and scale to make the preview fill the whole preview canvas
  //
  //
  rotateImageLeft = () => {
    this.cropper.current.rotate(-90);
    this.fitImageIntoCanvas(this.cropper.current);
  };

  rotateImageRight = () => {
    this.cropper.current.rotate(90);
    this.fitImageIntoCanvas(this.cropper.current);
  };

  fitImageIntoCanvas = (cropperElementRef) => {
    console.log("--- fitImageIntoCanvas");
    const cropperContainerSize = cropperElementRef.getContainerData();
    const { width: canvasWidth, height: canvasHeight } = cropperContainerSize;

    const imageSize = cropperElementRef.getImageData();
    const {
      width: imageWidth,
      height: imageHeight,
      rotate: imageRotation,
    } = imageSize;

    if (
      imageRotation !== 0 &&
      (imageRotation % 180 !== 0 || imageRotation % 180 !== -0)
    ) {
      const newImageHeightRatio = imageWidth / canvasHeight;
      const newImageWidthRatio = imageHeight / canvasWidth;

      if (imageWidth > canvasHeight || imageHeight > canvasWidth) {
        const useImageRatio =
          newImageHeightRatio > newImageWidthRatio
            ? 1 / newImageHeightRatio
            : 1 / newImageWidthRatio;

        cropperElementRef.scale(useImageRatio, useImageRatio);
      } else {
        const useImageRatio =
          newImageHeightRatio > newImageWidthRatio
            ? 1 / newImageHeightRatio
            : 1 / newImageWidthRatio;

        cropperElementRef.scale(useImageRatio, useImageRatio);
      }
    } else {
      cropperElementRef.scale(1, 1);
    }
  };
  //
  //
  // END: Rotate image and scale to make the preview fill the whole preview canvas

  componentDidMount() {}

  hasInputCaptureCamera = () => {
    const inputElement = document.createElement("input");
    return inputElement.capture !== undefined;
  };

  getUserDeviceGeolocation = () => {
    if (!navigator.geolocation) {
      return alert(
        "Dieser Web-Browser ermöglicht keine Abfrage Deines Ortes (geographische Koordinaten). Bitte versuche es mit einem anderen Web-Browser oder nutze eine der anderen Optionen das Bild zu verorten."
      );
    }

    // Start fetching location:
    this.setState({
      isFetchingLocationViaGeolocationApi: true,
    });

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setTimeout(() => {
          this.setCoordinates(latitude, longitude);
          this.setState({
            isFetchingLocationViaGeolocationApi: false,
          });
        }, 667);
      },
      () => {
        alert(
          "Das Abfrage Deines Ortes mithilfe dieses Web-Browsers schlug fehl. Bitte versuche es noch einmal oder nutze eine anderen Möglichkeit."
        );
        this.setState({
          isFetchingLocationViaGeolocationApi: false,
        });
      }
    );
  };

  getLocationByMap = () => {
    this.setState({
      isMapLocationSelectorVisible: true,
    });
  };

  setLocationByMap = (latitude, longitude) => {
    this.setCoordinates(latitude, longitude);
    this.setState({
      isMapLocationSelectorVisible: false,
    });
  };

  displayGeolocationInfo = (message, latitude, longitude) => {
    return (
      <div className="">
        <p className="tc geoLocationInfo">{message}</p>
        <ul className="list pl0 mv1 tc">
          <li>
            <b>LAT:</b> {latitude} | <b>LNG:</b> {longitude}
            <button
              onClick={this.resetCoordinates}
              className="bn ml1 link dim dib bg-white"
            >
              <img
                src={IconClose}
                style={{ verticalAlign: "middle" }}
                alt="reset coordinates"
              />
            </button>
          </li>
        </ul>
      </div>
    );
  };

  render() {
    // console.log("--- PhotoUpload props", this.props);

    const { latitude, longitude } = this.state.gpsCoordinates;
    const {
      isVisible,
      onShowPhotoUploader,
      isEmailValid,
      isFetchingLocationViaGeolocationApi,
      fileName,
      showStatusUploadRequest,
      showStatusUploadSuccess,
      showStatusUploadFailure,
      email,
      title,
      description,
      category,
      isMapLocationSelectorVisible,
      termsAccepted,
      newsletterSubscription,
      formErrors,
    } = this.state;

    const canUseCameraInfo = this.hasInputCaptureCamera() ? " | aufnehmen" : "";

    const photoUploader = (
      <PhotoUploadWrapper>
        <PluginCloseButton onClick={this.onClose} />
        <PhotoUploader>
          {Object.keys(formErrors).length !== 0 && (
            <div className="maxWidthFormElement m0 formErrors mb4 bg-light-red white">
              {Object.keys(formErrors).length !== 0 && (
                <h4 className="fw6 mt1 mb1 ">
                  Zur erfolgreichen Teilnahme fehlt noch:{" "}
                </h4>
              )}
              <ul className="pl4">
                {!formErrors.gpsCoordinates && (
                  <li>
                    Ein Bild <b>mit / und</b> Koordinaten.
                  </li>
                )}
                {!formErrors.email && <li>Eine gültige Email-Adresse.</li>}
                {!formErrors.terms && (
                  <li>
                    Akzeptanz v. Teilnahmebedingungen & Datenschutzrichtlinien.
                  </li>
                )}
              </ul>
            </div>
          )}
          <div className="maxWidthFormElement mt3">
            <label className="ttu db mb3 lh-copy" htmlFor="">
              <h2>Foto hochladen</h2>
            </label>

            <Dropzone onDrop={this.onDrop} accept="image/*" multiple={false}>
              {({
                getRootProps,
                getInputProps,
                isDragActive,
                isDragAccept,
                isDragReject,
              }) => (
                <Container
                  isDragActive={isDragActive}
                  isDragReject={isDragReject}
                  {...getRootProps()}
                  className="dropzone tc relative"
                  style={{ color: "rgba(129,51,78,1)" }}
                >
                  <img
                    src={IconUploadFoto}
                    className="absolute left-0"
                    style={{
                      height: "2rem",
                      verticalAlign: "middle",
                      top: "0.4rem",
                    }}
                    alt="Upload Icon"
                  />
                  <input {...getInputProps()} />

                  {isDragAccept
                    ? "Jetzt loslassen"
                    : fileName
                    ? fileName
                    : `Foto auswählen${canUseCameraInfo}`}
                  {fileName && (
                    <img
                      className="absolute right-0"
                      src={IconDelete}
                      alt="delete icon"
                      style={{
                        height: "1.3rem",
                        top: "0.8rem",
                        float: "right",
                      }}
                    />
                  )}
                </Container>
              )}
            </Dropzone>
          </div>
          {this.state.file && (
            <React.Fragment>
              <PreviewImageWrapper>
                <Cropper
                  style={{ width: "auto", height: "100%", margin: "0 auto" }}
                  ref={this.cropper}
                  src={this.state.file.preview}
                  crop={this.cropImage}
                  dragMode="none"
                  enable={false}
                  rotatable={true}
                  autoCrop={false}
                  autoCropArea={1.0}
                  ready={this.cropperReady}
                  guides={false}
                  highlight={false}
                  dragCrop={false}
                  zoomable={false}
                  scalable={true}
                  cropBoxMovable={false}
                  cropBoxResizable={false}
                />
                <ImageControls>
                  <Rotate left onClick={this.rotateImageLeft}>
                    <FontAwesomeIcon icon={faUndo} />
                  </Rotate>
                  <Rotate right onClick={this.rotateImageRight}>
                    <FontAwesomeIcon icon={faUndo} flip="horizontal" />
                  </Rotate>
                </ImageControls>
              </PreviewImageWrapper>
              {/* <PreviewImageWrapper>
              <PreviewImageUpload src={this.state.croppedImageUrl} />
            </PreviewImageWrapper> */}
              <div
                className="maxWidthFormElement getGeolocationForPhoto f6"
                style={{
                  color: "rgba(129,51,78, 1)",
                  borderColor: "rgba(129,51,78,0.5)",
                  maxWidth: "480px",
                }}
              >
                <div
                  className="br bl bb mt0 pb3 ph1 overflow-hidden relative"
                  style={{
                    borderColor: "rgba(129,51,78,0.5)",
                    borderWidth: "1px",
                    color: "rgba(129,51,78,1)",
                  }}
                >
                  {latitude && longitude ? (
                    this.displayGeolocationInfo(
                      "Dein Bild hat die folgenden GPS (Geo) - Koordinaten:",
                      latitude,
                      longitude
                    )
                  ) : (
                    <React.Fragment>
                      <p className="tc">
                        <em>
                          Dein Bild besitzt leider keine GPS (GEO) -
                          Informationen.
                        </em>
                      </p>
                      <div className="tj ph4">
                        <p className="o-70 f6">
                          Wir benötigen geographische Informationen, um das Bild
                          auf der Karte platzieren zu können.
                          <br />
                          Du kannst entweder ein neues Bild mit Koordinaten
                          hochladen,
                          <br />
                          oder eine der folgenden Alternativen nutzen:
                        </p>
                        <ul className="f6 list pl0 mv1 tc flex justify-center">
                          <li className="">
                            {isFetchingLocationViaGeolocationApi ? (
                              <Button>
                                <FontAwesomeIcon
                                  icon={faCrosshairs}
                                  className="pulse mr1 o-50"
                                />
                                Koordinatenabfrage läuft ...
                              </Button>
                            ) : (
                              <Button onClick={this.getUserDeviceGeolocation}>
                                Eigene Koordinaten nutzen
                              </Button>
                            )}
                          </li>
                          <li className="ml1">
                            <Button onClick={this.getLocationByMap}>
                              Position anhand Karte bestimmen
                            </Button>
                          </li>
                        </ul>
                        {isMapLocationSelectorVisible && (
                          <React.Fragment>
                            <div
                              className="mapAreaStretcher"
                              style={{ height: "80px" }}
                            />
                            <MapCoordinatesSelector
                              setCoordinates={this.setLocationByMap}
                            />
                          </React.Fragment>
                        )}
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </React.Fragment>
          )}

          <div className="maxWidthFormElement pv1 f6 mt3 ">
            <label className="light-silver db fw6 lh-copy" htmlFor="titel">
              Bildtitel:
            </label>
            <input
              className="pa2 input-reset ba bg-transparent w-100"
              type="text"
              name="titel"
              id="titel"
              onChange={this.handleTitleChange}
              value={title}
              style={{ borderColor: "rgba(129,51,78,0.5)" }}
            />
          </div>

          <div className="maxWidthFormElement mt3 pv1 f6">
            <label
              className="light-silver db fw6 lh-copy"
              htmlFor="email-address"
            >
              Email *:
              <small className="normal fr"> * Pflichtfeld! </small>
            </label>
            <input
              className="pa2 input-reset ba bg-transparent w-100"
              type="email"
              name="email-address"
              id="email-address"
              required={true}
              onChange={this.handleEmailChange}
              style={{ borderColor: "rgba(129,51,78,0.5)" }}
              value={email}
            />
            {/* {!isEmailValid && <small className="o-50">Hier bitte Deine Email - Adresse vollständig eintragen.</small>} */}
          </div>
          <div className="maxWidthFormElement mt3 pv1 f6">
            <label
              className="light-silver db fw6 lh-copy"
              htmlFor="email-address"
            >
              Kurzbeschreibung:
              <small className="normal fr">
                {" "}
                {`Noch ${
                  !!description ? 300 - description.length : 300
                } Zeichen`}{" "}
              </small>
            </label>
            <textarea
              className="pa2 input-reset ba bg-transparent w-100"
              name="description"
              maxLength="300"
              id="description"
              onChange={this.handleDescriptionChange}
              style={{ borderColor: "rgba(129,51,78,0.5)" }}
              value={description}
              rows="8"
            />
            {/* {!isEmailValid && <small className="o-50">Hier bitte Deine Email - Adresse vollständig eintragen.</small>} */}
          </div>
          <div className="maxWidthFormElement mt2 pv1 f6">
            <label className="light-silver db fw6 lh-copy" htmlFor="category">
              Kategorie *:
              <small className="normal fr"> * Pflichtfeld! </small>
            </label>
            <select
              value={category}
              name="category"
              id="category"
              className="pa2 input-reset ba bg-transparent w-100"
              onChange={this.handleCategoryChange}
            >
              {this.props.categories.filter(category => !!category.active ).map((category) => {
                return <option value={category.id}>{category.name}</option>;
              })}
            </select>
            {/* <input
              className="pa2 input-reset ba bg-transparent w-100"
              type="email"
              name="email-address"
              id="email-address"
              required={true}
              onChange={this.handleEmailChange}
              style={{ borderColor: "rgba(129,51,78,0.5)" }}
              value={email}
            /> */}
            {/* {!isEmailValid && <small className="o-50">Hier bitte Deine Email - Adresse vollständig eintragen.</small>} */}
          </div>
          {this.props.campaign && "Es gibt eine Campaigne"}
          <div className="maxWidthFormElement mt3 mb2 pv1">
            <label
              className="dn light-silver ttu fw6 lh-copy f6"
              htmlFor="accept-terms"
            >
              Teilnahmebedingungen und Datenschutz
            </label>
            <div className=" flex mt1">
              <input
                className="ma1"
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "1rem",
                  flexShrink: 0,
                  flexGrow: 0,
                }}
                type="checkbox"
                checked={termsAccepted}
                onChange={this.handleTermsAcceptance}
              />
              <p className="di ma0 f6 o-70">
                {/* Hiermit akzeptiere ich die
                <a
                  href="https://tourismus.ulm.de/de/infomieren/teilnahmebedingungen_gewinnspiel.php"
                  alt="Teilnahmebedingungen"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Teilnahmebedingungen{" "}
                </a> */}
                Ich habe die
                <a
                  href="https://tourismus.ulm.de/de/infomieren/datenschutzerklaerung.php"
                  alt="Datenschutzbestimmung"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Datenschutzbestimmungen{" "}
                </a>
                zur Kenntnis genommen.
              </p>
            </div>
          </div>
          <div className="maxWidthFormElement mt3 mb2 pv1">
            <label
              className="dn light-silver ttu fw6 lh-copy f6"
              htmlFor="accept-terms"
            >
              Newsletteranmeldung
            </label>
            <div className=" flex mt1">
              <input
                className="ma1 mr1"
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "1rem",
                  flexShrink: 0,
                  flexGrow: 0,
                }}
                type="checkbox"
                checked={newsletterSubscription}
                onChange={this.handleNewsletterSubscription}
              />
              <p className="di ma0 f6 o-70">
                Ich möchte denn Newsletter abonnieren.
              </p>
            </div>
          </div>
          <div className="maxWidthFormElement  pv1">
            <Button
              large
              className="f6 db center mt3"
              onClick={this.submitImageWithInfo}
            >
              <FontAwesomeIcon icon={faUpload} className="mr2 o-50" />
              Foto hochladen und teilnehmen
            </Button>
          </div>
        </PhotoUploader>
        <PhotoUploadStatus>
          <Status isVisible={showStatusUploadRequest}>
            <div className="ph4">
              <p>Dein Foto wird übertragen ...</p>
              <FontAwesomeIcon
                className="f1"
                style={{ color: "#81334E" }}
                icon={faSpinner}
                spin
              />
            </div>
          </Status>
          <Status
            isVisible={showStatusUploadSuccess}
            title="Danke!"
            approvePhrase="Ok"
            onClick={() => {
              window.location.reload();
            }}
          >
            <div className="ph4">
              <h3>
                Vielen Dank für deine Teilnahme!
                <br />
                Dein Foto wurde erfolgreich hochgeladen.
              </h3>
              {/* <p>
                Ihr Foto wurde erfolgreich hochgeladen und damit ihre Teilnahme
                am Wettbewerb bestätigt.
                <br />
                Im Falle eines Gewinns werden Sie benachrichtigt.
              </p> */}
            </div>
          </Status>
          <Status
            isVisible={showStatusUploadFailure}
            title="Uppppsss ...."
            approvePhrase="Ok"
          >
            <div className="ph4">
              <h3>Übertragung fehlgeschlagen</h3>
              <p>
                Leider gab es einen Fehler bei der Übertragung Deines Bildes.
                <br /> Bitte versuche es noch einmal oder versuche es mit der
                Desktop-Version.
              </p>
            </div>
          </Status>
        </PhotoUploadStatus>
      </PhotoUploadWrapper>
    );

    if (this.state.isVisible) {
      return photoUploader;
    } else {
      return (
        <div
          className="absolute left-0 right-0 bottom-1 flex justify-center"
          style={{ pointerEvents: "none" }}
        >
          <MapControlButtonWithText
            icon={IconUploadFoto}
            large={true}
            onClick={this.onShowPhotoUploader}
            style={{ pointerEvents: "all" }}
          >
            Foto hochladen
          </MapControlButtonWithText>
        </div>
      );
    }
  }
}

export default PhotoUpload;
